import { render, staticRenderFns } from "./pageheader.vue?vue&type=template&id=09acb9dc&scoped=true"
import script from "./pageheader.vue?vue&type=script&lang=ts"
export * from "./pageheader.vue?vue&type=script&lang=ts"
import style0 from "./pageheader.vue?vue&type=style&index=0&id=09acb9dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09acb9dc",
  null
  
)

export default component.exports